const ErrorMessage = ({ message }) => {
  return <div className="error_msg">{message}</div>;
};

export default ErrorMessage;
